import * as Report from 'containers/desktop/Reports/types/Report';
import * as ReportList from 'containers/desktop/Reports/types/ReportList';

export * as ReportGroup from 'containers/desktop/Reports/types/ReportGroup';

export type Type = {
	id: string;
	date: Date;
	reports: ReportList.Type;
	isSelected: boolean;
};

export function create(): Type {
	return {
		id: '',
		date: new Date(),
		reports: ReportList.create(),
		isSelected: false,
	};
}

export function toggleSelect(reportGroup: Type): Type {
	if (reportGroup.isSelected) {
		return {
			...reportGroup,
			isSelected: false,
			reports: ReportList.setSelectedToFalse(reportGroup.reports),
		};
	}
	return {
		...reportGroup,
		isSelected: true,
		reports: ReportList.setSelectedToTrue(reportGroup.reports),
	};
}

export function toggleSelectOfReport(reportGroup: Type, reportId: string): Type {
	return {
		...reportGroup,
		reports: reportGroup.reports.map((report) => {
			if (report.id === reportId) {
				return Report.toggleSelect(report);
			}
			return report;
		}),
	};
}
